import React, { useCallback } from 'react';
import { Button } from '@modernhealth/vital-components';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import { useLastRoute } from 'src/routing/RouteContext';

export const BackButton: React.FC<{
    children?: (previousRoute: string | null) => string | null;
    onClick?: (previousRoute: string | null, goBack: () => void) => void;
    fallbackPath?: string;
}> = ({ onClick, fallbackPath = '/circles', children }) => {
    const { t } = useTranslation('circles');
    const history = useHistory();
    const route = useLastRoute();

    const name = children?.(route?.pathname ?? null);

    const goBack = useCallback(() => {
        // Only go back if there is a location in history,
        // otherwise the user could exit our site
        if (route) {
            history.goBack();
        } else {
            history.push(fallbackPath);
        }
    }, [route, history, fallbackPath]);

    return (
        <Button
            onClick={() => (onClick ? onClick(route?.pathname ?? null, goBack) : goBack())}
            variant="flat"
            // TODO: The new Vita button doesn't support css={{}} yet
            style={{ paddingLeft: 0, paddingRight: 0 }}
            size="large"
            icon="arrow-left"
        >
            {name
                ? t('back_button.contextual', {
                      name,
                  })
                : t(`back_button.fallback`)}
        </Button>
    );
};
